import React, { Component } from 'react'
import { MuiTypography, muiWithStyles, MuiGrid, MuiButton, MuiDialog, MuiDialogActions, MuiDialogTitle, MuiDialogContent, MuiDialogContentText, MuiTextField } from '../../ui/MaterialUIComponents'
import theme from '../../../assests/theme'
export default class SubscriptionDialogComponent extends Component {
    render() {
        return (
            <div>
                <MuiDialog open={this.props.openCancelAlertDialog} aria-labelledby="form-dialog-title" maxWidth='xs'>
                    <MuiDialogTitle style={{ background: theme.palette.grey.dark }}>
                        <MuiGrid container>
                            <MuiGrid item xs container alignItems="center" justify="center" >
                                <MuiTypography style={{ fontFamily: "Arial", fontSize: '15px', color: "white" }}>
                                    {/* Buy License */}
                                    {this.props.i18n.license.cancelSubsciptionDialogTitle}
                                </MuiTypography>
                            </MuiGrid>
                        </MuiGrid>
                    </MuiDialogTitle>
                    <MuiDialogContent>
                        <MuiDialogContentText>
                            <MuiGrid container xs={12} justify="center">
                                <MuiTypography style={theme.typography.body2}>
                                    <span dangerouslySetInnerHTML={{ __html: this.props.i18n.license.cancelSubsciptionDialogDescription }}></span>
                                </MuiTypography></MuiGrid>
                        </MuiDialogContentText>
                    </MuiDialogContent>
                    <MuiDialogActions>
                        <MuiButton onClick={() => this.props.handleCloseCancelSubscriptionDialog()} style={theme.primaryButtonStyle}>
                            {/* Disagree */}
                            {this.props.i18n.license.cancelSubsciptionDialogDisagreeButton}
                        </MuiButton>
                        <MuiButton onClick={() => this.props.agreeCancelSubsciption()} style={theme.primaryButtonStyle}>
                            {/* Agree */}
                            {this.props.i18n.license.cancelSubsciptionDialogAgreeButton}
                        </MuiButton>
                    </MuiDialogActions>
                </MuiDialog>
            </div>
        );
    }
}